<template>
  <svg
    id="logo"
    width="100%"
    height="100%"
    version="1.1"
    viewBox="0 0 35.3 36"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <g id="logo" fill="#da1020">
      <path d="M35.17,25.72c-1.37,1.64-3.34,3.31-6.03,5.12-8.88,5.97-20.35,5.95-25.05-.04-1.9-2.43-2.63-5.41-2.11-8.61.83-5.12,4.8-10.26,11.17-14.47,2.03-1.34,3.56-1.34,4.48-1.09,1.19.31,1.87,1.11,2.09,1.54v.02c.46.88,1.52,2.93-2.59,6.14-8.15,6.36-11,12.06-8.03,16.06,3.1,4.19,13.11,3.98,19.83-.42,2.1-1.38,3.92-2.56,5.63-4.61.2-.25.42-.22.54-.12.14.12.17.35.06.48Z" />
      <path d="M.07,10.2c1.37-1.64,3.34-3.32,6.03-5.12,8.88-5.97,20.35-5.96,25.05.04,1.9,2.43,2.63,5.41,2.11,8.61-.84,5.12-4.8,10.26-11.17,14.47-2.03,1.34-3.56,1.33-4.48,1.09-1.18-.31-1.87-1.11-2.09-1.54v-.02c-.46-.88-1.52-2.93,2.59-6.14,8.15-6.36,11-12.06,8.03-16.06-3.11-4.19-13.11-3.98-19.84.42-2.1,1.38-3.92,2.56-5.63,4.61-.2.25-.42.22-.54.12-.14-.12-.17-.35-.06-.48Z" />
    </g>
  </svg>
</template>
